module.exports = __webpack_public_path__ + "static/media/previaje.2e4d0f53.pdf";